import { useEffect } from 'react';
import { useAuthStore } from './auth';

/**
 * Run the boot-time session check exactly once for the lifetime of the SPA.
 *
 * Pings `/admin/v1/_session` to find out whether the HttpOnly cookie is
 * present. This is an *optimistic* check — it does not validate the token's
 * signature or expiry, only its existence. Real validation happens upstream
 * the next time the SPA makes an authenticated API call. The split keeps
 * unauthenticated visitors off the Worker's hot path and avoids bouncing
 * authenticated visitors back to `/sign-in` on every full page load.
 *
 * Validates Requirement 20.1.
 */
export function useSession(): void {
  const bootstrapAuth = useAuthStore((s) => s.bootstrapAuth);
  useEffect(() => {
    void bootstrapAuth();
    // bootstrapAuth is a stable Zustand action; we deliberately run this once
    // at mount and rely on `setAuth` / `clearAuth` for subsequent updates.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
